export default {
  EDIT_RETIREMENT_FUND_GOAL_PLAN_STATE_MANAGER: Symbol.for('EDIT_RETIREMENT_FUND_GOAL_PLAN_STATE_MANAGER'),
  EDIT_RETIREMENT_FUND_GOAL_PLAN_CURRENT_PLAN_SERVICE: Symbol.for('EDIT_RETIREMENT_FUND_GOAL_PLAN_CURRENT_PLAN_SERVICE'),
  EDIT_RETIREMENT_FUND_GOAL_PLAN_CURRENT_AMOUNT_SERVICE: Symbol.for('EDIT_RETIREMENT_FUND_GOAL_PLAN_CURRENT_AMOUNT_SERVICE'),
  EDIT_RETIREMENT_FUND_GOAL_PLAN_RETIREMENT_AGE_SERVICE: Symbol.for('EDIT_RETIREMENT_FUND_GOAL_PLAN_RETIREMENT_AGE_SERVICE'),
  EDIT_RETIREMENT_FUND_GOAL_PLAN_DEFINE_BY_SERVICE: Symbol.for('EDIT_RETIREMENT_FUND_GOAL_PLAN_DEFINE_BY_SERVICE'),
};
